import React, { useEffect, useState } from 'react'
import { Grid, Paper, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import { IPayloadCreateCompteParentalEtab } from '.';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import ListeTuteur2 from './ListeTuteur2';


export interface IAddProps {
  state: IPayloadCreateCompteParentalEtab;
  setState: (x: IPayloadCreateCompteParentalEtab) => void;
  numerosTuteurs: string[];
  optionSelected: any;
  setOptionSelected: any;
  listeTuteurs: any;
  setNumerosTuteurs: any;
  handleClick: any;
}


export interface IListeTuteur {
  numeroCellulaire: string;
  anneeScolaire: string;
  codeEtab: string;
  idEleve: number;
  filiation: string;
  nomPrenomParent: string;
  professionParent?: any;
  residenceParent?: any;
  emailParent?: any;
  souscriptionFocusEcole: number;
  createdAt: string;
  updatedAt: string;
  status?: any;
  matricule?: string;
  nomEleve?: string;
  prenomEleve?: string;
  telephoneTuteur?: string;
  nomPrenomTuteur?: string;
  idClasse?: number;
  idTypeclasse?: number;
  libelleClasseCourt?: string;
  libelleClasseLong?: string;
}



export const Add = (props: IAddProps) => {


  const {handleClick, state, setState, numerosTuteurs, optionSelected, setOptionSelected, listeTuteurs, setNumerosTuteurs } = props


  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setState({ ...state, [name]: value })
  }

  const handleChange = (event: any) => {
    setOptionSelected((event.target as any).value);
  };


  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={2}
      >
        <Grid item md={6} xs={12} sm={6}>
          <Grid
            container
            spacing={2}
          >

            <Grid item xs={12} sm={12} md={12}>
              <TextField
                fullWidth
                size="small"
                name="codeEtab"
                label="Code établissement"
                value={state.codeEtab}
                onChange={handleInputChange}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <TextField
                fullWidth
                size="small"
                name="anneeScolaire"
                label="Année scolaire"
                value={state.anneeScolaire}
                onChange={handleInputChange}
              />
            </Grid>

            <Grid item md={12} xs={12} sm={12}>
              <FormControl>
                <RadioGroup
                  row
                  value={optionSelected}
                  onChange={handleChange}
                >
                  <FormControlLabel value={"excel"} control={<Radio />} label="Par fichier excel" />
                  <FormControlLabel value={"select"} control={<Radio />} label="Par selection" />
                </RadioGroup>
              </FormControl>
            </Grid>


            {/* {optionSelected === "excel" &&
              <Grid item xs={12} sm={12} md={12}>
                <h3>Charger le fichier Excel</h3>
                <input type="file" accept=".xls,.xlsx" onChange={handleFileUpload} />
                <h4>Liste des Tuteurs : ({numerosTuteurs.length}) </h4>
                <Paper sx={{ width: '100%', mb: 2, backgroundColor: "#fcfafc", height: "30vh", overflow: "auto" }}>
                  <ul>
                    {numerosTuteurs?.map((tutor, index) => (
                      <li key={index}>{tutor}</li>
                    ))}
                  </ul>
                </Paper>
              </Grid>}

            {optionSelected === "select" && */}
              <Grid item xs={12} sm={12} md={12}>
                <ListeTuteur2
                  listeTuteurs={listeTuteurs}
                  setNumerosTuteurs={setNumerosTuteurs}
                  numerosTuteurs={numerosTuteurs}
                  handleClick={handleClick}
                />
              </Grid>
              {/* } */}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};



